export function evaluationCriteriaListAll() {
  return '{evaluationCriteriaListAll{id, name, active}}';
}

export function evaluationCriteriaRemove(value) {
  return `mutation {evaluationCriteriaRemove(id: ${value.id})}`;
}

export function evaluationCriteriaSave(values) {
  return `mutation {
        evaluationCriteriaSave(                              
          evaluationCriteria: {id: ${values.id ? values.id : 0}
                        , name: "${
                          values.name
                        }"                                            
                        , description: """${values.description}"""
                        , active: ${values.active}
                        , filterByStatus: false                                        
                        , updaterId: 0
                    }),
        {id}
    }`;
}

export function evaluationCriteriaListByFilter(filter) {
  const query = `{evaluationCriteriaListByFilter(filter:  ${JSON.stringify(
    filter
  ).replace(/"([^(")"]+)":/g, '$1:')}) {id, name, description, active}}`;
  return query;
}
